import importandexport from "../assets/Import&ExportManagement.jpg";
import distribution from "../assets/distribution.png";
import partnerships from "../assets/partnerships.png";
import medicalEquipment from "../assets/medicalEquipment.png";
import postSales from "../assets/postSales.png";
export const services = [
  {
    image: importandexport,
    title: "Import & Export Management",
    description:
      "Coordinating sourcing, documentation, and logistics for medical and commercial products under UK and international trade regulations.",
  },
  {
    image: distribution,
    title: "Distribution & Trading Services",
    description:
      "Acting as a UK-based trading and distribution agency, supplying medical and commercial products to hospitals, clinics, healthcare distributors, and business partners across the United Kingdom and international markets.",
  },
  {
    image: partnerships,
    title: "Trading Representation & Agency Partnerships",
    description:
      "We help manufacturers expand via expert partnership management, supplier coordination, and strategic negotiations tailored to UK and international markets.",
  },
  {
    image: medicalEquipment,
    title: "Refurbished & Used Medical Equipment",
    description:
      "Sourcing and supplying tested, certified used and refurbished medical equipment from the UK and Europe to healthcare institutions worldwide.",
  },
  {
    image: postSales,
    title: "Post-Sale Support & Training",
    description:
      "Through our manufacturing and distribution partners, we provide technical support, product training, and ongoing assistance to ensure client satisfaction and product reliability.",
  },
];
